module.exports = __webpack_public_path__ + "static/media/reco_1.9ce6d3b9.jpg";